var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState, } from 'react';
import { getClientData } from '#services';
import { UserClientContext } from './UserClientContext';
/**
 *  - This provides info about the user's device and user's browser.
 *  Currently it is used to provide information needed for mobile fallback screen.
 *
 *  - In the future it will be used to also provide information regarding
 *  responsive design (resolution, aspect-ratios, etc...)
 **/
export const UserClientProvider = ({ children }) => {
    _react_refresh_temp_2();
    const windowIdRef = useRef(crypto.randomUUID());
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    useEffect(() => {
        const updateNetworkState = () => setIsOnline(navigator.onLine);
        updateNetworkState();
        window.addEventListener('online', updateNetworkState);
        window.addEventListener('offline', updateNetworkState);
        return () => {
            window.removeEventListener('online', updateNetworkState);
            window.removeEventListener('offline', updateNetworkState);
        };
    }, []);
    const { isAndroid, isIos, isMobile } = useMemo(() => getClientData(), []);
    const value = useMemo(() => ({
        isAndroid,
        isIos,
        isMobile,
        isOnline,
        windowId: windowIdRef.current,
    }), [isAndroid, isIos, isMobile, isOnline]);
    return (_jsx(UserClientContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = UserClientProvider;
$RefreshReg$(_react_refresh_temp_1, "UserClientProvider");
_react_refresh_temp_2(UserClientProvider, "jP4Gvqa9pDovwQMUvvSojAtBLIc=");
